import React, { useEffect, useMemo } from 'react';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import { LoaderMi, ButtonGroup, ButtonLink } from '@si-armes/dsfr-react';
import { connect } from 'react-redux';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import { getDateFRFromYYYYMMDDHHMMSS } from 'components/Commun/Form/Date/dateTranformation';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BoutonFichierTelechargeable from 'components/Commun/Fichier/BoutonFichierTelechargeable';
import usagerClientReducer from '../../../store/usagerReducer';
import RoutesVisualiserCeaf from '../mes-demarches/ceaf/visualiser/routes';
import {
    API_CARTE_COLLECTIONNEUR,
    API_CEAF_GENERATION_PDF,
    API_POST_CEAF_RECUPERER_DERNIERE_EDITEE,
    CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE,
    CONTEXT_CARTE_COLLECTIONNEUR,
    CONTEXT_CEAF_GENERATION_PDF,
} from '../../../constants/apiUrls.constants';
import CarteCollectionneurRetraitTelechargementBouton from './components/carteCollectionneur/CarteCollectionneurRetraitTelechargementBouton';
import {
    INFOS_CEAF_PDF,
    MIME_APPLICATION_OCTET_STREAM,
    MIME_APPLICATION_PDF,
} from '../../../constants/fileConstant';
import MesAutorisations from '../mes-demarches/components/mesAutorisations/MesAutorisations';
import { getPath } from '../../../utils/router';
import { CEAF } from '../../../constants/accessibilite.constants';

// TODO: Ne pas oublier de mettre en place la gestion des rôles dans le back quand elle sera implémentée
// TODO: Cette partie est inaccessible pour les chasseurs
const MesTitresDeDetention = ({
    getApi,
    erreur,
    reinitialiseApi,
    dataDerniereCeafEditee,
    isLoadingDerniereCeafEditee,
    dataCeafPdfBase64,
    isLoadingCeafPdfBase64,
    dataCarteCollectionneur,
}) => {
    const {
        statut: statutCeaf,
        dateExpiration: dateExpirationCeaf,
        uuid: uuidCeaf,
        numeroCeaf,
        dateInit: dateInitCeaf,
    } = dataDerniereCeafEditee || {};

    useEffect(() => {
        getApi(
            usagerClientReducer,
            API_POST_CEAF_RECUPERER_DERNIERE_EDITEE,
            CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE,
        );
        getApi(usagerClientReducer, API_CARTE_COLLECTIONNEUR, CONTEXT_CARTE_COLLECTIONNEUR);

        return () => {
            reinitialiseApi(CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE);
            reinitialiseApi(CONTEXT_CARTE_COLLECTIONNEUR);
        };
    }, [erreur]);

    const urlVisualiserCeaf = getPath(RoutesVisualiserCeaf, {
        uuidCeaf: dataDerniereCeafEditee ? uuidCeaf : null,
    });

    const genererPdfCeaf = () => {
        if (dataDerniereCeafEditee) {
            getApi(
                usagerClientReducer,
                API_CEAF_GENERATION_PDF + uuidCeaf,
                CONTEXT_CEAF_GENERATION_PDF,
            );
        }
    };

    const getActionsCeaf = () => {
        return (
            <ButtonGroup inline align="center">
                <ButtonLink
                    as={statutCeaf === 'Valide' ? Link : undefined}
                    to={urlVisualiserCeaf}
                    variant="secondary"
                    icon="fr-fi-eye-line"
                    title={`Visualiser ma ${CEAF}`}
                    disabled={statutCeaf !== 'Valide'}
                >
                    Visualiser ma <abbr>{CEAF}</abbr>
                </ButtonLink>
                <BoutonFichierTelechargeable
                    handleOnClick={genererPdfCeaf}
                    label={
                        <div>
                            Télécharger ma <abbr>{CEAF}</abbr>
                        </div>
                    }
                    title="Télécharger ma CEAF"
                    isLoading={isLoadingCeafPdfBase64}
                    titreFichier={INFOS_CEAF_PDF}
                    mimeType={MIME_APPLICATION_PDF || MIME_APPLICATION_OCTET_STREAM}
                    contenu={dataCeafPdfBase64}
                    disabled={statutCeaf !== 'Valide'}
                    iconOnly
                />
            </ButtonGroup>
        );
    };

    const donneeCeaf = useMemo(() => {
        if (dataDerniereCeafEditee) {
            return [
                numeroCeaf,
                statutCeaf,
                getDateFRFromYYYYMMDDHHMMSS(dateInitCeaf),
                statutCeaf === 'Valide' ? getDateFRFromYYYYMMDDHHMMSS(dateExpirationCeaf) : '-',
                getActionsCeaf(),
            ];
        }
        return [];
    }, [dataDerniereCeafEditee, dataCeafPdfBase64, isLoadingCeafPdfBase64]);

    const titresCarteEuropeenneArmesFeu = [
        'N° de la carte',
        'Statut',
        'Date de délivrance',
        "Date d'expiration",
        'Actions',
    ];

    const titresCarteCollectionneur = ['N° de la carte', 'Date de retrait', 'Actions'];

    const donneeCarteCollectionneur = useMemo(() => {
        if (!dataCarteCollectionneur) {
            return [];
        }
        return [
            dataCarteCollectionneur.numero,
            dataCarteCollectionneur.dateRetrait,
            <CarteCollectionneurRetraitTelechargementBouton
                numero={dataCarteCollectionneur.numero}
                key={`telechargement-carte-collectionneur-${dataCarteCollectionneur.numero}`}
            />,
        ];
    }, [dataCarteCollectionneur]);

    const donneesVides = [
        [
            <>
                Aucune <abbr>{CEAF}</abbr> n'a encore été éditée
            </>,
            '',
            '',
            '',
            '',
        ],
    ];

    return (
        <div className="margin-bottom-lg">
            <h1>Mes titres de détention</h1>
            <br />
            <h2 className="font-size-lg margin-top-sm">Ma carte européenne d&apos;armes à feu</h2>

            <div className="position-relative" style={{ minHeight: '130px' }}>
                {isLoadingDerniereCeafEditee && <LoaderMi taille="md" />}
                {!isLoadingDerniereCeafEditee && (
                    <SimpleTable
                        entete={titresCarteEuropeenneArmesFeu}
                        donnees={
                            Array.isArray(donneeCeaf) && donneeCeaf.length
                                ? [donneeCeaf]
                                : donneesVides
                        }
                        boutonActionsPresent
                        caption={
                            <>
                                Liste de mes <abbr>{CEAF}</abbr>
                            </>
                        }
                    />
                )}
            </div>

            {dataCarteCollectionneur && (
                <>
                    <br />
                    <h2 className="font-size-lg margin-top-sm">Ma carte de collectionneur</h2>
                    <SimpleTable
                        entete={titresCarteCollectionneur}
                        donnees={[donneeCarteCollectionneur]}
                        boutonActionsPresent
                        caption="Ma carte de collectionneur"
                    />
                </>
            )}

            <br />
            <h2 className="font-size-lg margin-top-xs">Mes autorisations</h2>
            <MesAutorisations />
        </div>
    );
};

MesTitresDeDetention.propTypes = {
    reinitialiseApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    erreur: PropTypes.bool,
    dataDerniereCeafEditee: PropTypes.shape({
        statut: PropTypes.string.isRequired,
        dateExpiration: PropTypes.string.isRequired,
        uuid: PropTypes.string.isRequired,
        numeroCeaf: PropTypes.string.isRequired,
        dateInit: PropTypes.string.isRequired,
    }),
    isLoadingDerniereCeafEditee: PropTypes.bool,
    dataCeafPdfBase64: PropTypes.object,
    isLoadingCeafPdfBase64: PropTypes.bool,
    dataCarteCollectionneur: PropTypes.shape({
        numero: PropTypes.string,
        dateRetrait: PropTypes.string,
    }),
};

export default connect(
    (state) => {
        const { data: dataDerniereCeafEditee, isLoading: isLoadingDerniereCeafEditee } =
            state.ceaf.recuperDerniereEditee;

        const {
            data: dataCeafPdfBase64,
            erreur,
            isLoading: isLoadingCeafPdfBase64,
        } = state.ceaf.fichierPdfBase64;

        const { data: dataCarteCollectionneur } = state.carteCollectionneur.recuperer;

        return {
            dataDerniereCeafEditee,
            erreur,
            isLoadingDerniereCeafEditee,
            dataCeafPdfBase64,
            isLoadingCeafPdfBase64,
            dataCarteCollectionneur,
        };
    },
    {
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(MesTitresDeDetention);
